import Components from "./components";
import {companyDividends, CompanyDividends} from "./CompanyDividendsTabComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.dividends`;

    return angular.module(moduleName, [Components(moduleName)])
                  .component(CompanyDividends, companyDividends())
                  .name;
}
